/**
 * A wrapper component that provides the Wizard context to its children.
 *
 * @param {WizardWrapperProps} props - The properties for the WizardWrapper component.
 * @param {ReactNode} props.children - The child components that will be wrapped by the WizardProvider.
 *
 * @returns {JSX.Element} The WizardProvider component wrapping the children.
 */
import React, { ReactNode } from 'react';
import { WizardProvider } from './WizardContext';

interface WizardWrapperProps {
  children: ReactNode;
}

export const WizardWrapper = ({ children }: WizardWrapperProps) => <WizardProvider>{children}</WizardProvider>;
